import {hashCode} from './hashCode'

export function generateNameSpaceColor(namespace: string, lightness: number = 90): string {
  const hash = hashCode(namespace);
  const hue = hash % 360;
  return `hsl(${hue}, 100%, ${lightness}%)`;
}